<template>
    <div class="fhfbpmt_container" v-if="false">
        <div class="title_bg">
            <h2>云南前列电缆有限责任公司</h2>
            <div class="subtitle">能源一体化管控平台 负荷分布图</div>
        </div>
        <div class="popss ssleft">
            <img
                src="../../../assets/image/index-fhfb/left_gk.png"
                style="height: 100%; width: 3rem; position: absolute; left: 0"
            />
            <!-- <img class="sider-tit" src="../../../assets/image/index-yn/left-su.png" /> -->
            <div class="left_top">
                <div class="left_top_wrapper">
                    <div
                        class="div-content"
                        v-for="(item, index) in picData"
                        :key="index"
                    >
                        <div class="top_pic">
                            <img :src="item.img" />
                        </div>
                        <div>{{ item.name }}</div>
                        <div>{{ item.data }}{{ item.unit }}</div>
                    </div>
                </div>
            </div>
            <div class="left_fle left_mid">
                <div class="left_mid_title" style="width: 170px">
                    <!-- <img src="../../../assets/image/index-yn/title.png" style="height: 1rem; width: auto;"/> -->
                    <div>
                        当前变压器负载率&nbsp;&nbsp;{{ bianyaqiSum
                        }}<i v-show="bianyaqiSum">%</i>
                    </div>
                </div>
                <div class="left_mid_cnt">
                    <div
                        class="div-content fit_margin"
                        v-for="(item, index) in bianyaqiData"
                        :key="index"
                    >
                        <div
                            style="
                display: flex;
                align-items: center;
                width: calc(100% + 55px);
              "
                        >
                            <div style="width: 65px">
                                {{ item.doc_name }}({{ item.capacity }})
                            </div>
                            <div
                                style="flex: 1"
                                @mouseenter="toggleLoad(item, 1)"
                                @mouseleave="toggleLoad(item, 0)"
                            >
                                <el-progress
                                    :text-inside="true"
                                    :stroke-width="item.width"
                                    :percentage="item.percent"
                                    :color="item.color"
                                ></el-progress>
                            </div>
                            <div class="load_value">
                                <span
                                    v-if="
                                        currentFuzai &&
                                            item.doc_name ==
                                                currentFuzai.doc_name
                                    "
                                    >{{ item.load_value }}</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="left_fle left_bot">
                <div class="left_mid_title">
                    <div>告警事件</div>
                </div>
                <div class="left_mid_cnt" style="height: auto">
                    <div
                        class="div-content fit_margin"
                        v-for="(item, index) in gaojingData"
                        :key="index"
                    >
                        <div style="display: flex; align-items: center">
                            <div>
                                <img
                                    src="../../../assets/image/index-yn/alarm.png"
                                    style="width: 15px; height: 15px"
                                />
                            </div>
                            <div style="width: 35%; margin-left: 6px">
                                {{ item.cur_time }}
                            </div>
                            <div style="width: 55px">{{ item.point_name }}</div>
                            <div style="flex: 1">
                                <span
                                    :class="[
                                        item.warn_level == '20'
                                            ? 'color_green'
                                            : 'color_red'
                                    ]"
                                    >{{ item.warn_level_name }}</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="center_wrapper">
            <img
                src="../../../assets/image/index-fhfb/fhfbpmt_center.gif"
                class="center_bg"
            />
            <img
                src="../../../assets/image/index-fhfb/g_yellow.png"
                class="center_pic"
                style="top: 11%; left: 12.4%; cursor: pointer;"
                @click="() => this.$router.push('/Power_execl')"
            />
            <div class="yihao title">配电室</div>
            <div class="center_cnt yihao1">
                <div>
                    当前变压器负载率: <i>{{ bianyaqiSum }}%</i>
                </div>
                <div>变压器运行容量: <i>2620kVA</i></div>
                <div>变压器数量: <i>5台</i></div>
            </div>
            <img
                src="../../../assets/image/index-fhfb/m_green.png"
                class="center_pic"
                style="top: 29%; left: 12.4%"
            />
            <div class="shiwai title">室外仓库</div>
            <div class="center_cnt shiwai1">
                <div>额定负荷: <i>300kW</i></div>
                <div>实际负荷: <i>287.3kW</i></div>
                <div>监测点位: <i>3个</i></div>
            </div>
            <img
                src="../../../assets/image/index-fhfb/m_green.png"
                class="center_pic"
                style="top: 29%; left: 40.8%"
            />
            <div class="yichejian title">一号车间</div>
            <div class="center_cnt yichejian1">
                <div>额定负荷: <i>300kW</i></div>
                <div>实际负荷: <i>287.3kW</i></div>
                <div>监测点位: <i>3个</i></div>
            </div>
            <img
                src="../../../assets/image/index-fhfb/m_green.png"
                class="center_pic"
                style="top: 46.7%; left: 53%"
            />
            <div class="erchejian title">二号车间</div>
            <div class="center_cnt erchejian1">
                <div>额定负荷: <i>300kW</i></div>
                <div>实际负荷: <i>287.3kW</i></div>
                <div>监测点位: <i>3个</i></div>
            </div>
            <el-popover placement="top-start" width="200" trigger="click">
                <div
                    class="popupdiv"
                    v-for="item in sanhaochejian"
                    :key="item.key"
                >
                    <i>{{ item.key }}</i
                    >：{{ item.value }}
                </div>
                <img
                    src="../../../assets/image/index-fhfb/m_green.png"
                    class="center_pic"
                    style="top: 63.7%; left: 65.5%"
                    slot="reference"
                />
            </el-popover>
            <div class="sanchejian title">三号车间</div>
            <div class="center_cnt sanchejian1">
                <div>额定负荷: <i>300kW</i></div>
                <div>实际负荷: <i>287.3kW</i></div>
                <div>监测点位: <i>3个</i></div>
            </div>
            <img
                src="../../../assets/image/index-fhfb/m_lang.png"
                class="center_pic"
                style="top: 80.7%; left: 12.4%"
            />
            <div class="bangong title">办公大楼</div>
            <div class="center_cnt bangong1">
                <div>负荷使用情况: <i>300kW</i></div>
            </div>
            <img
                src="../../../assets/image/index-fhfb/m_lang.png"
                class="center_pic"
                style="top: 80.7%; left: 65.5%"
            />
            <div class="yuangong title">员工宿舍</div>
            <div class="center_cnt yuangong1">
                <div>负荷使用情况: <i>300kW</i></div>
            </div>
        </div>
        <div class="popss ssright">
            <!-- <img src="../../../assets/image/index-yn/pop-right.png" /> -->
            <div class="left_fle right_top">
                <div class="left_mid_title">
                    <div>电量情况</div>
                </div>
                <div class="right_mid_cnt">
                    <div
                        class="div-content"
                        v-for="(item, index) in dianliangData"
                        :key="index"
                    >
                        <div style="display: flex; align-items: center">
                            <div style="width: 20%">
                                <img
                                    :src="item.img"
                                    style="width: 25px; height: auto"
                                />
                            </div>
                            <div style="width: 35%">{{ item.name }}</div>
                            <div class="cnt_data">
                                <i>{{ item.data }}</i
                                >&nbsp;{{ item.unit }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="left_fle right_top_chart">
                <v-chart
                    :auto-resize="true"
                    :options="dianliangqingkuang"
                    ref="dianliangqingkuang"
                />
            </div>
            <div class="left_fle right_bot">
                <div class="left_mid_title">
                    <div>负荷情况</div>
                </div>
                <div class="right_mid_cnt">
                    <div
                        class="div-content"
                        v-for="(item, index) in fuheData"
                        :key="index"
                    >
                        <div style="display: flex; align-items: center">
                            <div style="width: 20%">
                                <img
                                    :src="item.img"
                                    style="width: 25px; height: auto"
                                />
                            </div>
                            <div style="width: 35%">{{ item.name }}</div>
                            <div class="cnt_data">
                                <i>{{ item.data }}</i
                                >&nbsp;{{ item.unit }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="left_fle right_bot_chart">
                <v-chart :auto-resize="true" :options="fuhe" ref="fuhe" />
            </div>
        </div>
        <!-- <div class="ssbottom">
        <div class="bottom_cnt"
        v-for="(item, index) in dianfeiData"
        :key="index"
        >
            <div style="width: 10%">
            <img :src="item.img" style="width: 25px; height: auto" />
            </div>
            <div style="width: 45%;">{{ item.name }}</div>
            <div class="bot_data">
            <i>{{ item.data }}</i
            >&nbsp;{{ item.unit }}
            </div>
        </div>
        <div style="wdith: 33.3%"></div>
        <div style="flex:1"></div>
    </div> -->
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import utils from "@/utils/utils.js";
import {
    getSysDate,
    getElecInfo,
    getUnitPointList,
    getMonthPower,
    getYearPower,
    getLoad,
    getDayLoad,
    getMonthLoad
} from "@/http/Use_electricity_monitor";
import {
    getHourDemand,
    getAlarmList,
    getIndexInfo,
    getTransformerLoad
} from "@/http/hr";
export default {
    name: "fhfbpmt",
    components: {},
    data() {
        return {
            picData: [
                {
                    img: require("../../../assets/image/index-yn/zhuangji.png"),
                    name: "装机容量",
                    data: "",
                    unit: "kVA"
                },
                {
                    img: require("../../../assets/image/index-yn/peidianshi.png"),
                    name: "配电室",
                    data: "",
                    unit: "个"
                },
                {
                    img: require("../../../assets/image/index-yn/jisuan.png"),
                    name: "计算装置数量",
                    data: "",
                    unit: "个"
                },
                {
                    img: require("../../../assets/image/index-yn/caiji.png"),
                    name: "采集器数量",
                    data: "",
                    unit: "个"
                },
                {
                    img: require("../../../assets/image/index-yn/bianyaqi.png"),
                    name: "变压器数量",
                    data: "",
                    unit: "个"
                },
                {
                    img: require("../../../assets/image/index-yn/dangri.png"),
                    name: "当日采集成功率",
                    data: "",
                    unit: "%"
                }
            ],
            dianliangData: [
                {
                    img: require("../../../assets/image/index-yn/dianliang1.png"),
                    name: "当日用电量",
                    data: "",
                    unit: "kW·h"
                },
                {
                    img: require("../../../assets/image/index-yn/dianliang2.png"),
                    name: "当月用电量",
                    data: "",
                    unit: "kW·h"
                },
                {
                    img: require("../../../assets/image/index-yn/dianliang3.png"),
                    name: "当年用电量",
                    data: "",
                    unit: "kW·h"
                }
            ],
            dianfeiData: [
                {
                    img: require("../../../assets/image/index-fhfb/A.png"),
                    name: "基本电费基准线",
                    data: "100",
                    unit: "元"
                },
                {
                    img: require("../../../assets/image/index-fhfb/C.png"),
                    name: "基本电费实际值",
                    data: "100",
                    unit: "元"
                },
                {
                    img: require("../../../assets/image/index-fhfb/D.png"),
                    name: "项目节省费用",
                    data: "100",
                    unit: "元"
                }
            ],
            fuheData: [
                {
                    img: require("../../../assets/image/index-yn/fuhe1.png"),
                    name: "当日最大负荷",
                    data: "",
                    unit: "kW"
                },
                {
                    img: require("../../../assets/image/index-yn/dianliang2.png"),
                    name: "当月最大负荷",
                    data: "",
                    unit: "kW"
                },
                {
                    img: require("../../../assets/image/index-yn/dianliang3.png"),
                    name: "日平均负荷率",
                    data: "",
                    unit: "kW"
                }
            ],
            bianyaqiSum: "",
            bianyaqiData: [
                {
                    name: "1#变压器",
                    width: 15,
                    percent: "65",
                    color: "#1989fa"
                },
                {
                    name: "1#变压器",
                    width: 15,
                    percent: "65",
                    color: "#1989fa"
                },
                {
                    name: "1#变压器",
                    width: 15,
                    percent: "65",
                    color: "#1989fa"
                },
                {
                    name: "1#变压器",
                    width: 15,
                    percent: "65",
                    color: "#1989fa"
                },
                {
                    name: "1#变压器",
                    width: 15,
                    percent: "65",
                    color: "#1989fa"
                }
            ],
            gaojingData: [
                // {
                //   time: "2021-06-01",
                //   name: "1#变压器",
                //   state: "0",
                // },
                // {
                //   time: "2021-06-01",
                //   name: "1#变压器",
                //   state: "0",
                // },
                // {
                //   time: "2021-06-01",
                //   name: "1#变压器",
                //   state: "0",
                // },
                // {
                //   time: "2021-06-01",
                //   name: "1#变压器",
                //   state: "0",
                // },
                // {
                //   time: "2021-06-01",
                //   name: "1#变压器",
                //   state: "0",
                // },
            ],
            sanhaochejian: [
                { key: "额定负荷", value: "1000" },
                { key: "当前设备", value: "1000" },
                { key: "启用情况", value: "1000" },
                { key: "实际负荷", value: "1000" },
                { key: "历史参数", value: "1000" }
            ],
            dianlianglegend: [],
            dianliang_xAxis: [],
            dianliang_unit: "",
            dianliang_series: [],
            chart2_legend: [],
            chart2x_unit: "",
            chart2_x: [],
            chart2_y1: [],
            chart2_y2: [],
            chart2_y3: [],
            currentFuzai: null,
            timer: ""
        };
    },
    mounted() {
        // this.getSysTime();
    },
    created() {
        this.timer = setInterval(() => {
            // this.getSysTime();
        }, 10000);
    },
    methods: {
        //获取系统时间
        getSysTime() {
            getSysDate().then(res => {
                if (res && res.error_code === "0") {
                    this.currentDay = res.bus_json.sysdate;
                    this.currentMonth = res.bus_json.sysdate3;
                    this.currentYear = res.bus_json.sysdate4;
                    this.getLoad();
                    //获取电量情况
                    this.getPointList();
                    //告警
                    this.getAlarmList(this.currentDay);
                    //左上图标
                    this.getIndexInfo();
                    //变压器负载情况
                    this.getTransformerLoad();
                }
            });
        },
        toggleLoad(item, type) {
            this.currentFuzai = item;
            if (type == 0) {
                this.currentFuzai = null;
            }
            console.log(11111111111);
            console.log(item);
        },
        //负荷情况
        getLoad() {
            getLoad().then(res => {
                if (res && res.error_code === "0") {
                    this.fuheData[0].data = res.bus_json.max_load;
                    this.fuheData[1].data = res.bus_json.month_load;
                    this.fuheData[2].data = res.bus_json.avg_load;
                    //获取当日负荷
                    this.getDayLoad();
                }
            });
        },
        //获取当日负荷
        getDayLoad() {
            getDayLoad().then(res => {
                if (res && res.error_code === "0") {
                    this.chart2_legend = ["负荷", "环比", "同比"];
                    this.chart2x_unit = "";
                    this.chart2_x = res.bus_json.x;
                    this.chart2_y1 = res.bus_json.y;
                    this.chart2_y2 = res.bus_json.hby;
                    this.chart2_y3 = res.bus_json.tby;
                }
            });
        },
        //获取根节点
        getPointList() {
            getUnitPointList().then(res => {
                if (res && res.error_code === "0") {
                    this.rootPointId =
                        res.bus_json.length > 0 && res.bus_json[0].point_id;
                    this.getElecInfo(this.rootPointId, this.currentDay, 0);
                    //this.getElecInfo(this.rootPointId, '2021-05-25', 0);
                }
            });
        },
        //获取用电量
        getElecInfo(point_id, date) {
            getElecInfo({ point_id, date }).then(res => {
                if (res && res.error_code === "0") {
                    this.dianliangData[0].data = res.bus_json.active_power_day;
                    this.dianliangData[0].unit = res.bus_json.dayUnit;
                    this.dianliangData[1].data =
                        res.bus_json.active_power_month;
                    this.dianliangData[1].unit = res.bus_json.monthUnit;
                    this.dianliangData[2].data = res.bus_json.active_power_year;
                    this.dianliangData[2].unit = res.bus_json.yearUnit;
                    this.dianliang_xAxis = res.bus_json.hour_list;

                    this.dianlianglegend = [
                        "尖电量",
                        "峰电量",
                        "平电量",
                        "谷电量"
                    ];
                    this.dianliang_unit = "时";
                    this.dianliang_series = [
                        {
                            name: "尖电量",
                            type: "bar",
                            stack: "elc",
                            data: res.bus_json.sharp_power_list,
                            itemStyle: {
                                color: "#fe7f66"
                            }
                        },
                        {
                            name: "峰电量",
                            type: "bar",
                            stack: "elc",
                            data: res.bus_json.peak_power_list,
                            itemStyle: {
                                color: "#fdca50"
                            }
                        },
                        {
                            name: "平电量",
                            type: "bar",
                            stack: "elc",
                            data: res.bus_json.off_power_list,
                            itemStyle: {
                                color: "#0091ea"
                            }
                        },
                        {
                            name: "谷电量",
                            type: "bar",
                            stack: "elc",
                            data: res.bus_json.shoulder_power_list,
                            itemStyle: {
                                color: "#29b85e"
                            }
                        }
                    ];
                }
            });
        },
        getTransformerLoad() {
            getTransformerLoad().then(res => {
                if (res && res.error_code === "0") {
                    const data = res.bus_json;
                    this.bianyaqiSum = data.transformer_rate_sum;
                    this.bianyaqiData = [];
                    data.transformerRateList.forEach(item => {
                        let obj = {};
                        obj.doc_name = item.doc_name;
                        obj.percent = item.transformer_rate;
                        obj.capacity = item.capacity
                            ? item.capacity + "kVA"
                            : "";
                        obj.load_value = item.load_value;
                        obj.color = "#1989fa";
                        obj.width = "15";
                        if (item.transformer_rate >= 80) {
                            obj.color = "#e6a23c";
                        }
                        this.bianyaqiData.push(obj);
                    });
                }
            });
        },
        getAlarmList(date) {
            getAlarmList({
                date: date,
                pageNum: 1,
                pageSize: 5
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.gaojingData = res.bus_json.items;
                }
            });
        },
        getIndexInfo() {
            getIndexInfo().then(res => {
                if (res && res.error_code === "0") {
                    this.picData[0].data = res.bus_json.zjrl;
                    this.picData[1].data = res.bus_json.pds;
                    this.picData[2].data = res.bus_json.jlzz;
                    this.picData[3].data = res.bus_json.collector_count;
                    this.picData[4].data = 5; //res.bus_json.trans_count;
                    this.picData[5].data = res.bus_json.success_rate;
                }
            });
        }
    },
    computed: {
        dianliangqingkuang() {
            const options = {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: this.dianlianglegend,
                    itemWidth: 8,
                    itemHeight: 8,
                    right: 0,
                    textStyle: {
                        color: utils.getFontColor(),
                        fontSize: 8
                    }
                },
                grid: {
                    left: "0%",
                    right: "0%",
                    bottom: "0%",
                    top: "15%",
                    containLabel: true
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: this.dianliang_unit,
                        data: this.dianliang_xAxis,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "kW·h",
                        position: "left",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: this.dianliang_series
            };
            return options;
        },
        fuhe() {
            const options = {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: this.chart2_legend,
                    itemWidth: 10,
                    itemHeight: 10,
                    right: 0,
                    textStyle: {
                        color: utils.getFontColor(),
                        fontSize: 8
                    }
                },
                grid: {
                    left: "0%",
                    right: "0%",
                    bottom: "0%",
                    top: "18%",
                    containLabel: true
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: this.chart2x_unit,
                        data: this.chart2_x,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "kW",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "负荷",
                        type: "line",
                        data: this.chart2_y1,
                        itemStyle: {
                            color: "#fe7f66"
                        },
                        smooth: true,
                        symbol: "none"
                    },
                    {
                        name: "环比",
                        type: "line",
                        data: this.chart2_y2,
                        itemStyle: {
                            color: "#fdca50"
                        },
                        smooth: true,
                        symbol: "none"
                    },
                    {
                        name: "同比",
                        type: "line",
                        data: this.chart2_y3,
                        itemStyle: {
                            color: "#0091ea"
                        },
                        smooth: true,
                        symbol: "none"
                    }
                ]
            };
            return options;
        }
    },
    beforeDestroy() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss">
.el-popover {
    // .popupwrapper {
    //     height: 500px;width: 100%; overflow-y: auto;display: flex; flex-flow: row wrap;
    .popupdiv {
        border-bottom: 1px dotted #a0a0a0;
        padding: 0.5rem 0;
        width: 100%;
        i {
            font-weight: bold;
        }
    }
    // }
}
.fhfbpmt_container {
    // padding: 0 0 0 2rem;
    //font-size: 0.8rem;
    height: 100%;
    position: relative;
    //margin: 0 -10px;
    // .bg_pic {
    //     @include background_index_img('fhfbpmt-bgimg');
    //     height: 100%;
    //     width: 100%;
    //     background-size: 98% auto !important;
    //     background-position: top center !important;
    // }
    .title_bg {
        // @include background_index_img('fhfbpmt-bgimg');
        height: 4.5rem;
        width: 100%;
        background: url("../../../assets/image/index-fhfb/title_bg.png")
            no-repeat;
        background-size: 100% 90% !important;
        background-position: top center !important;
        padding-top: 0.5rem;
        box-sizing: border-box;
        h2 {
            font-size: 1.4rem;
            color: #fff;
            letter-spacing: 3px;
            //   margin-top: 1rem;
        }
        .subtitle {
            font-size: 1.1rem;
            color: #fff;
            margin-top: 0.3rem;
            letter-spacing: 1.5px;
        }
    }
    .center_wrapper {
        float: left;
        margin: 0 10px;
        width: calc(100% - 39% - 20px);
        color: #fff;
        .title {
            font-size: 0.85rem;
        }
        position: relative;
        .center_bg {
            width: 95%;
            height: auto;
        }
        .center_pic {
            position: absolute;
            width: 2.2rem;
            height: auto;
        }
        .center_cnt {
            position: absolute;
            text-align: left;
            font-size: 0.65rem;
            // @include border;
            padding: 0 2px 2px 2px;
            > div {
                margin-top: 0.3rem;
                i {
                    color: #f6d41f;
                }
            }
        }
        .yihao {
            position: absolute;
            top: 19.5%;
            left: 12%;
        }
        .yihao1 {
            position: absolute;
            top: 17%;
            left: 19%;
        }
        .shiwai {
            position: absolute;
            top: 38%;
            left: 11.5%;
        }
        .shiwai1 {
            position: absolute;
            top: 34.5%;
            left: 19%;
        }
        .yichejian {
            position: absolute;
            top: 38%;
            left: 40%;
        }
        .yichejian1 {
            position: absolute;
            top: 35%;
            left: 47.5%;
        }
        .erchejian {
            position: absolute;
            top: 55%;
            left: 52%;
        }
        .erchejian1 {
            position: absolute;
            top: 52%;
            left: 59.5%;
        }
        .sanchejian {
            position: absolute;
            top: 72%;
            left: 64%;
        }
        .sanchejian1 {
            position: absolute;
            top: 69.5%;
            left: 71.5%;
        }
        .bangong {
            position: absolute;
            top: 89%;
            left: 12%;
        }
        .bangong1 {
            position: absolute;
            top: 86%;
            left: 19.5%;
        }
        .yuangong {
            position: absolute;
            top: 89%;
            left: 65%;
        }
        .yuangong1 {
            position: absolute;
            top: 86%;
            left: 72.5%;
        }
    }
    .popss {
        position: relative;
        height: calc(100% - 1.5rem);
        margin-top: -3rem;
        float: left;
        .div-content {
            color: #fff;
            .load_value {
                // @include font_color();
                width: 55px;
            }
            .cnt_data {
                flex: 1;
                text-align: right;
                i {
                    color: #fff;
                    font-size: 0.8rem;
                }
            }
        }
        .fit_margin {
            margin-top: 0.8rem;
        }
        //  border: 1px solid red;
        img {
            width: 210px;
            height: auto;
        }
        .right_top {
            width: 100%;
            height: 22%;
            position: absolute;
            top: 2%;
            color: #fff;
        }
        .right_top_chart {
            width: 100%;
            height: 26%;
            position: absolute;
            top: 24%;
            color: #fff;
            .echarts {
                width: 100%;
                height: 100%;
            }
        }
        .right_bot {
            width: 100%;
            height: 22%;
            position: absolute;
            top: 50%;
            color: #fff;
        }
        .right_bot_chart {
            width: 100%;
            height: 26%;
            position: absolute;
            top: 72%;
            color: #fff;
            .echarts {
                width: 100%;
                height: 100%;
            }
        }
        .left_top {
            width: 100%;
            height: 35%;
            position: absolute;
            top: 0;
            color: #fff;
            margin-left: 1rem;
            .left_top_wrapper {
                display: flex;
                flex-flow: row wrap;
                height: 100%;
                width: 100%;
                padding: 0.8rem 1rem;
                box-sizing: border-box;

                > div {
                    height: 33%;
                    width: 50%;
                    .top_pic {
                        height: 40%;
                        width: 100%;
                        > img {
                            width: 1.3rem;
                            height: 1.1rem;
                        }
                    }
                    > div {
                        font-size: 0.6rem;
                        margin-top: 4px;
                    }
                }
            }
        }
        .left_fle {
            width: 100%;
            position: absolute;
            color: #fff;
            padding: 12px;
            box-sizing: border-box;
            .left_mid_cnt {
                display: flex;
                justify-content: space-around;
                flex-flow: column;
                // height: calc(100% - 20px);
                height: auto;
            }
            .right_mid_cnt {
                display: flex;
                justify-content: space-around;
                flex-flow: column;
                height: calc(100% - 20px);
            }
            .left_mid_title {
                height: 20px;
                width: 120px;
                background: url(../../../assets/image/index-yn/title.png);
                background-size: 100% 100%;
                margin-bottom: 5px;
                &:first-child {
                    height: 20px;
                    line-height: 20px;
                    font-size: 0.6rem;
                }
            }
        }
        .left_mid {
            height: 30%;
            top: 34%;
            margin-left: 2.5rem;
            width: calc(100% - 2.5rem);
        }
        .left_bot {
            height: 32%;
            top: 65%;
            margin-left: 1rem;
        }
    }
    .ssleft {
        // top: 0;
        // left: 0;
        width: 18%;
        .sider-tit {
            position: absolute;
            top: 50%;
            left: 3px;
            transform: translate(0, -50%);
            width: 2rem;
            height: auto;
        }
    }
    .ssright {
        // top: 0;
        // right: 0;

        width: 21%;
    }
    .ssbottom {
        position: absolute;
        bottom: 15px;
        width: 52%;
        margin: 0 24%;
        display: flex;
        flex-flow: row;
        color: #fff;
        .bottom_cnt {
            width: 33.3%;
            display: flex;
            flex-flow: row;
            align-items: center;
            //   margin: 0 10px 0 10px;
        }
        .bot_data {
            flex: 1;
            i {
                color: #fff;
                font-size: 0.8rem;
            }
        }
    }

    .color_red {
        color: rgb(207, 27, 27);
    }
    .color_green {
        color: rgb(18, 175, 71);
    }
    .color_yellow {
        color: rgb(190, 179, 13);
    }
}
@media screen and (max-width: 1440px) {
    .ssleft {
        width: 21% !important;
    }
    .ssright {
        width: 21% !important;
    }
    .center_wrapper {
        width: calc(100% - 42% - 20px) !important;
        // img {
        //     width: 94% !important;
        //     height: auto !important;
        // }
    }
}
</style>
